import React, {useEffect, useRef} from 'react';
import Anchor from '../data/Anchor';
import Flex from '../data/Flex';
import Size from '../data/Size';
import { listen, unlisten } from '../dispatcher/Dispatcher';
import UIEvent from '../events/UIEvent';
import useOutsideClick from '../hooks/useOutsideClick';
import { UICloseButton } from './UIButton';
import { UIWhiteBox } from './UIContainer';
import { copyFlex, IFlex, IUIFlexProps } from './UIFlex';

import './UIPopup.scss';


export interface IUIPopupProps extends IUIFlexProps{
    anchor?:string;
    style?:string;
    showing?:boolean;
    insideFlex?:IFlex;
    closeID?:string;
    
    noPadding?:boolean;
    /**
     * Default font size s14
     */
    fontSize?:string;
    hideCloseBtn?:boolean;
    onCloseClick?:()=>void;
}


export const STYLE_WHITE:string = "white";

export default function UIPopup($props:IUIPopupProps){

    let cn:string = "popup";
    let showing = $props.showing?true:false;
    if(showing) cn+=" showing";
    if($props.className) cn+=" "+$props.className;

    let anchor = $props.anchor || Anchor.BOTTOM_CENTER;
    let style = $props.style || STYLE_WHITE;

    const whiteBox = useRef<UIWhiteBox>(null);

    cn+=" anchor_"+anchor;
    cn+=" style_"+style;

    cn = Size.addFontSize(cn,$props.fontSize,Size.s14);

    let popupFlex:IFlex = {
        direction:Flex.COLUMN
    }

    const _close=()=>{    
        if($props.onCloseClick){
            $props.onCloseClick();
        }
    }
    let showCloseBtn:boolean=true;

    if($props.hideCloseBtn){
        showCloseBtn=false;
    }
    
    useOutsideClick(showing,_close,whiteBox.current?.divRef);


    //This next section gives a way for other things unrelated to also CLOSE the popup.
    const onClosePopup=($event:UIEvent)=>{
        if($event.data===$props.closeID){
            _close();
        }
    }
    useEffect(()=>{
        let isListening:boolean=false;
        if(showing){
            isListening=true;
            listen(UIEvent.CLOSE_POPUP,onClosePopup);        
        }
        return ()=>{
            if(isListening){
                unlisten(UIEvent.CLOSE_POPUP,onClosePopup);
            }
        }
    },[showing]);



    return (
        <UIWhiteBox ref={whiteBox} noPadding={$props.noPadding} className={cn} flex={copyFlex(popupFlex,$props.flex)}>
            
            {$props.children}
            {$props.onCloseClick && showCloseBtn && (
                <UICloseButton onClick={_close}/>
            )}
        </UIWhiteBox>
    );
}
